module.exports = __webpack_public_path__ + "img/tanzamap.0e9f7c79.png";